import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import CategoryModel from '@/model/CategoryModel.js';

/**
 * @method apiGetCategory
 */

 export default {
    apiGetCategory: function (token, categoryParam) {
        var url = Vue.bzbsConfig.bzbsUrl + "/campaigncat/menu";
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, token, categoryParam)
                .then((response) => {
                    var categories = [];
                    for (var i of response.data) {
                        var category = new CategoryModel(i);
                        categories.push(category);
                    }

                    resolve(categories);
                }).catch((error) => {
                    reject(error);
                });

        });
    }
 }
